<script>
import { useAlert } from 'dashboard/composables';
import { CONTACTS_EVENTS } from '../../../helper/AnalyticsHelper/events';
import { useTrack } from 'dashboard/composables';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    activeCustomView: {
      type: Object,
      default: () => {},
    },
    customViewsId: {
      type: [String, Number],
      default: 0,
    },
    activeFilterType: {
      type: Number,
      default: 0,
    },
    openLastItemAfterDelete: {
      type: Function,
      default: () => {},
    },
  },
  emits: ['close', 'update:show'],
  data() {
    return { deletionError: '', isDeleting: false };
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    activeCustomViews() {
      if (this.activeFilterType === 0) {
        return 'conversation';
      }
      if (this.activeFilterType === 1) {
        return 'contact';
      }
      return '';
    },
    // Título com o nome e texto dizendo o que NÃO some: o medo de quem
    // confirma é perder as conversas ou os contatos, não o atalho.
    deleteTitle() {
      const name = this.activeCustomView?.name || '';
      if (this.activeFilterType === 1) {
        return this.$t(
          'CONTACTS_LAYOUT.HEADER.ACTIONS.FILTERS.DELETE_SEGMENT.TITLE',
          { name }
        );
      }
      return this.$t('FILTER.CUSTOM_VIEWS.DELETE.MODAL.CONFIRM.TITLE', {
        name,
      });
    },
    deleteMessage() {
      return this.activeFilterType === 1
        ? this.$t(
            'CONTACTS_LAYOUT.HEADER.ACTIONS.FILTERS.DELETE_SEGMENT.DESCRIPTION'
          )
        : this.$t('FILTER.CUSTOM_VIEWS.DELETE.MODAL.CONFIRM.MESSAGE');
    },
    deleteConfirmText() {
      return `${this.$t('FILTER.CUSTOM_VIEWS.DELETE.MODAL.CONFIRM.YES')}`;
    },
    deleteRejectText() {
      return `${this.$t('FILTER.CUSTOM_VIEWS.DELETE.MODAL.CONFIRM.NO')}`;
    },
    isFolderSection() {
      return this.activeFilterType === 0 && this.$route.name !== 'home';
    },
    isSegmentSection() {
      return (
        this.activeFilterType === 1 && this.$route.name !== 'contacts_dashboard'
      );
    },
  },

  methods: {
    async deleteSavedCustomViews() {
      // trava o segundo clique enquanto o DELETE anterior não volta
      if (this.isDeleting) return;
      this.isDeleting = true;
      this.deletionError = '';
      try {
        const id = Number(this.customViewsId);
        const filterType = this.activeCustomViews;
        await this.$store.dispatch('customViews/delete', { id, filterType });
        this.closeDeletePopup();
        useAlert(
          this.activeFilterType === 0
            ? this.$t('FILTER.CUSTOM_VIEWS.DELETE.API_FOLDERS.SUCCESS_MESSAGE')
            : this.$t('FILTER.CUSTOM_VIEWS.DELETE.API_SEGMENTS.SUCCESS_MESSAGE')
        );
        useTrack(CONTACTS_EVENTS.DELETE_FILTER, {
          type: this.activeFilterType === 0 ? 'folder' : 'segment',
        });
        this.openLastItemAfterDelete();
      } catch {
        this.deletionError =
          this.activeFilterType === 0
            ? this.$t('FILTER.CUSTOM_VIEWS.DELETE.API_FOLDERS.ERROR_MESSAGE')
            : this.$t('FILTER.CUSTOM_VIEWS.DELETE.API_SEGMENTS.ERROR_MESSAGE');
      } finally {
        this.isDeleting = false;
      }
    },
    closeDeletePopup() {
      this.deletionError = '';
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div>
    <woot-delete-modal
      v-if="localShow"
      v-model:show="localShow"
      :on-close="closeDeletePopup"
      :on-confirm="deleteSavedCustomViews"
      :title="deleteTitle"
      :message="deleteMessage"
      :error-message="deletionError"
      :confirm-text="deleteConfirmText"
      :reject-text="deleteRejectText"
      :is-loading="isDeleting"
    />
  </div>
</template>
